import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {LeadCommentModel} from '../models/superbit-api-models'
import moment from 'moment';
import AddRnewalCommentPopup from './_AddRnewalCommentPopup'
import { RenewalsModel } from '../models/RenewalsModel';

type Props = {
    data: LeadCommentModel[] | null;
    sortBy?: any;
    className?: string;
    config?: any;
    actions?: any;
    fromLeads?: boolean;
    fromClient?: boolean;
};




const RenewalComments = (props: Props) => {

    const dispatch = useDispatch();

    const [taskItemsList, setTaskItemsList] = useState<any[]>([]);
    const [showDropDown, setShowDropDown] = useState(false);

    const [data, setData] = useState<LeadCommentModel[] | null>(null);


    const [sortBy, setSortBy] = useState<any | null>(null);
    const [fromLeadTableType, setfromLeadTableType] = useState<boolean>(false);

    const [showEditReferencePopUp, setShowEditReferencePopUp] = useState(false);
    const [showEditHandlerTreatmentPopUp, setShowEditHandlerTreatmentPopUp] = useState(false);

    const [treatmentIdForEdit, setTreatmentIdForEdit] = useState<string>('');
    const [treatmentData, setTreatmentData] = useState<any>(null);
    const [addCommentPopup, setAddCommentPopup] = useState<boolean>(false);


useEffect(() => {
    setData(props.data);
    console.log("RenewalComments data",props.data);    
    }, []);


const addComment = (e: any) => {
        setAddCommentPopup(true);
    }

    const deleteComment = async (id: any) => {
await new RenewalsModel().RenewalLeadCommentAddDelete(id);

        if(data && data.length>0 && data[0].leadId){
            let _data = await new RenewalsModel().RenewalGetLeadComments(data[0].leadId);
            setData(_data);
        }
    }

    

    const ClosePopup = () => {
        setAddCommentPopup(false);
    }

    const ClosePopupAndLoad = async () => {
        setAddCommentPopup(false);
        if(data && data.length>0 && data[0].leadId){
            let _data = await new RenewalsModel().RenewalGetLeadComments(data[0].leadId);
            setData(_data);
        }
    }

    
  

    return (

        <>
        {data && data.length>0 && addCommentPopup? <AddRnewalCommentPopup leadId={data[0].leadId} ClosePopup={() => ClosePopup()} ClosePopupAndLoad={() => ClosePopupAndLoad()} />:""}
            <div className="details-row no-padding offers">
                    <div className="row-title">
                        פרטים נוספים והערות
                    </div>
                    <div className='flex-centered' style={{ marginLeft: "10px" }}>
                            <button type="button" onClick={(e: any) => addComment(e)} className="button blue has-icon flex-centered flex-justify-center">
                                    <div className="icon add"></div>
                                    הוסף הערה
                                </button>
                        </div>
                    <div id="offersTbl" className="content-table-header flex-centered flex-space-between">
                        <div className="cell status pointer" >
                            תאריך
                        </div>
                        <div className="cell date flex-centered flex-space-between pointer">
                            מבצע השינוי
                        </div>
                        <div className="cell date flex-centered flex-space-between pointer" >
                            נושא
                        </div>
                        <div className="cell date flex-centered flex-space-between pointer" >
                           פירוט
                        </div>
                        <div className="cell date flex-centered flex-space-between pointer" >
                           
                        </div>
                        
                        
                                    </div>
                                    {data ? data.map((comment: LeadCommentModel, index: number) => {
                                        return (
                                            <>
                                                <div className="detailsscontent-row flex-centered flex-space-between">
                                                    <div className="cell date">
                                                        {moment(comment.createdDate).format('DD-MM-YYYY')}
                                                    </div>
                                                    <div className="cell-price">
                                                        {comment.user?comment.user.fullName:"No User"}                                                        
                                                    </div>
                                                    <div className="cell-price">
                                                        {comment.topic}
                                                    </div>
                                                    <div className="cell-price">
                                                        {comment.text}
                                                    </div>
                                                    <div className="cell-price">
                                                        <div onClick={(e: any) => deleteComment(comment.id)} className="icon trash-brown pointer"></div>
                                                    </div>
                                                </div>


                                            </>
                                        )
                                    }) : ""}

                                </div>            
        </>

    )
}
export default RenewalComments;